/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1TutoraiConfigMemoryQueryResponse,
  GetApiV1TutoraiConfigMemoryQueryParams,
  GetApiV1TutoraiConfigMemory401,
  GetApiV1TutoraiConfigMemory500,
} from "../../types/tutorAIConfigController/GetApiV1TutoraiConfigMemory.ts";

function getGetApiV1TutoraiConfigMemoryUrl() {
  const res = { method: "GET", url: `/api/v1/tutorai/config/memory` as const };
  return res;
}

/**
 * @description Retorna o contexto injetado nos prompts. Hierarquia de fallback: aluno (`personId` + `classStudentId`) → turma (`classStudentId`) → global. `content` é `null` quando não configurada. **(Requer Authorization para autenticação)**
 * @summary Obter memória do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/memory}
 */
export async function getApiV1TutoraiConfigMemory(
  params?: GetApiV1TutoraiConfigMemoryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1TutoraiConfigMemoryQueryResponse,
    ResponseErrorConfig<
      GetApiV1TutoraiConfigMemory401 | GetApiV1TutoraiConfigMemory500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1TutoraiConfigMemoryUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
